export default __webpack_public_path__ + "static/media/mainlogo.a53e79fb.png";